import React, { useState } from 'react'
import styled from 'styled-components'
import { UIStyles } from '../../theme'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import CropMasterLogo from '../../assets/img/cropMaster/crop_master_2_lines.svg'
// import { findLogoType } from './CropMaster'

import split from 'lodash/split'
import last from 'lodash/last'
import get from 'lodash/get'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getLocale } from '../../selectors/i18n'

const SvgWrapper = styled.img`
  width: 60px;
  transition: all 0.3s ease-in-out;
  &:hover {
    filter: brightness(1.1);
    transform: scale(1.05);
  }
`

const AvatarCropMasterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  padding: 8px;
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  height: 100%;
  border-radius: 4px;

  &:hover {
    background-color: ${props => !props.disabled && 'rgba(255, 255, 255, 0.1)'};
    transform: translateY(-1px);
  }

  ${SvgWrapper} {
    filter: ${props => (props.isActive ? 'none' : 'none')};
  }
`

const ImageWrapper = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  transition: all 0.2s ease;
  &:hover {
    filter: brightness(1.1);
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 10px;
  right: 8px;
  cursor: ${props => (props.hasRoleIrriga ? 'default' : 'pointer')};
  width: '100px';
  height: '50px';
  border-radius: 50%;
  z-index: 2;
  transition: all 0.2s ease;
  /* A soft white ring on hover, kept while the user menu is open so it shows where the menu came from. */
  box-shadow: ${props => (props.isMenuOpen ? `0 0 0 3px ${UIStyles.lightGrayHoverColor}` : 'none')};
  &:hover {
    background-color: ${props => !props.hasRoleIrriga && 'rgba(255, 255, 255, 0.1)'};
    box-shadow: ${props => !props.hasRoleIrriga && `0 0 0 3px ${UIStyles.lightGrayHoverColor}`};
  }
`

const IconWrapper = styled.i`
  display: flex;
  color: ${themeColors.deepblueColor3};
  background: ${props => (props.srcLogo ? UIStyles.blueColor : UIStyles.whiteColor)};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: all 0.2s ease;
  &:hover {
    filter: brightness(1.1);
  }
`

const AvatarWrapper = styled.div`
  display: inline-flex;
  height: 60px;
  width: auto;
  min-width: 200px;
  min-width: ${props => (props.hasCropMasterRole ? '140px' : '60px')};
`

const Avatar = ({ user, hasRoleIrriga, handleToggleMenu, isCropMaster, isMenuOpen = false }) => {
  const [imageError, setImageError] = useState(false)
  const agroUserLogo = get(user, 'agro__customers[0].agro_user.user.logo')
  const bucketUrl = process.env.REACT_APP_BUCKET
  const bucketName = last(split(bucketUrl, '//'))
  const logoBaseUrl = `https://${bucketName}.s3.eu-west-2.amazonaws.com/logos/`

  const isUserLogo = !user.isNullObject() && user.logo
  const isCooperative = get(user, 'agro__customers[0].agro__cooperative')
  const isCooperativeLogo = isCooperative?.user?.logo || null
  const isAgroUserLogo = agroUserLogo || null
  const srcLogo = isUserLogo || (isCooperative ? isCooperativeLogo : isAgroUserLogo)
  const hasCropMasterRole = user.roles?.includes('ROLE_CROP_MASTER') || false
  const navigate = useNavigate()
  const locale = useSelector(getLocale)
  // const { logo } = useMemo(() => findLogoType(user.roles), [user.roles])

  const generateUrl = route => (locale !== 'es' ? '/' + locale : '') + '/' + route

  const handleImageError = () => {
    setImageError(true)
  }

  const showImage = srcLogo && !imageError

  return (
    <AvatarWrapper hasCropMasterRole={hasCropMasterRole}>
      {hasCropMasterRole && (
        <AvatarCropMasterWrapper onClick={() => navigate(generateUrl('crop-master'))} isActive={isCropMaster}>
          <SvgWrapper src={CropMasterLogo} style={{ 'margin-bottom': ' 0px' }} />
          {/*  <SvgWrapper src={logo} /> */}
        </AvatarCropMasterWrapper>
      )}
      <Wrapper onClick={handleToggleMenu} hasRoleIrriga={hasRoleIrriga} isMenuOpen={isMenuOpen} data-testid="avatar-wrapper">
        {showImage ? (
          <ImageWrapper data-testid="avatar-image" src={`${logoBaseUrl}${srcLogo}`} onError={handleImageError} />
        ) : (
          <IconWrapper className="fa-solid fa-user" />
        )}
      </Wrapper>
    </AvatarWrapper>
  )
}

export default Avatar
